<template>
    <div class="h-content">
    <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" class="h-dialog2 liaddress" :modal="true">
        <div class="h-dialogImg">
            <div class="h-disTable">
                <div class="h-tableCell">
                    <h1>选择地址</h1>
                    <p>Choose Address</p>
                </div>
            </div>
        </div>
        <el-form :model="form" ref="form" class="demo-form-inline h-formbLine1" style="margin-top:0.2rem; padding: 0 0.2rem;">
			<div class="w-city">
				<el-form-item label="省" class="h-elformWrap-2" prop="sheng" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
				    <el-select v-model="form.sheng" @change="handleItemChange1" placeholder="省"  style="width: 68%;">
				        <el-option
				            v-for="item in shenglist"
				            :key="item.value"
				            :label="item.name"
				            :value="item.code">
				        </el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="市" class="h-elformWrap-2" prop="shi"
				        :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
				    <el-select v-model="form.shi" @change="handleItemChange2"
				            :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
				            placeholder="市"  style="width: 68%;">
				        <el-option
				            v-for="item in arealist2"
				            :key="item.value"
				            :label="item.name"
				            :value="item.code">
				        </el-option>
				    </el-select>
				</el-form-item>
			</div>
			<div class="w-city">
				<el-form-item label="区" class="h-elformWrap-2" prop="qu"
				    :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
				    <el-select v-model="form.qu" @change="handleItemChange3"
				            :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
				            placeholder="区" style="width: 68%;">
				        <el-option
				                v-for="item in arealist3"
				                :key="item.value"
				                :label="item.name"
				                :value="item.code">
				        </el-option>
				    </el-select>
				</el-form-item>
				<el-form-item label="乡/镇/街道" class="h-elformWrap-2" prop="zhen">
				    <el-select v-model="form.zhen" placeholder="乡/镇/街道" style="width: 68%;">
				        <el-option
				            v-for="item in arealist4"
				            :key="item.value"
				            :label="item.name"
				            :value="item.code">
				        </el-option>
				    </el-select>
				</el-form-item>
			</div>
            <div class="w-controny">
				<el-form-item label="详细地址" class="h-elformWrap-1"
				        :rules="[
				            { required: true, message: '必须输入选项', trigger: 'blur'},
				            {  max: 100, message: '长度在100个字符以内', trigger: 'blur' }
				        ]"
				        prop="addrdetail">
				    <el-input v-model="form.addrdetail" style="width: 84%;"></el-input>
				</el-form-item>
			</div>
                
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="submit-btn-w" type="primary" @click="huidiao">确 定</el-button>
        </div>
    </el-dialog>
    </div>
</template>

<script>
    import ss from '../api/SystemService'

    export default {
        name: "areaSelect",
        data() {
            return {
                form: {
                    id: '',
                    sheng: '',
                    shi: '',
                    qu: '',
                    zhen: '',
                    addrdetail: '',
                },
                shenglist:[],
                arealist1: [],
                arealist2: [],
                arealist3: [],
                arealist4: [],

                props: {
                    label: 'name',
                    value: 'code',
                    children: 'cities'
                },
                query: {
                    pcode: 0,
                    level: 1,
                }
            }
        },
        props: {
            xxdz: {
                type: String,
            }
        },
        created() {
            this.form.addrdetail = this.xxdz || '';
            this.loadArea();
        },
        methods: {
            huidiao() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.form.shengobj = _.find(this.shenglist,{code:this.form.sheng});
                        this.form.shiobj = _.find(this.arealist2,{code:this.form.shi});
                        this.form.quobj = _.find(this.arealist3,{code:this.form.qu});
                        this.form.id = this.form.quobj.code;
                        if(this.arealist4.length>0 && this.form.zhen){
                            this.form.zhenobj = _.find(this.arealist4,{code:this.form.zhen});
                        }
                        this.$emit('choseObj', this.form);
                    }
                });
            },
            loadArea(i) {
                ss.Dictservice.arealist(this.query).then(rd => {
                    this.shenglist = rd;
                })
            },
            handleItemChange1(o){
                this.form.sheng = o;
                ss.Dictservice.areaTreelist({code:o}).then(rd => {
                    this.form.shi = '';
                    this.form.qu = '';
                    this.form.zhen = '';
                    this.arealist2 = rd.zlist;
                    this.arealist3 = [];
                    this.arealist4 = [];
                })
            },
            handleItemChange2(o){
                this.form.qu = '';
                this.form.zhen = '';
                this.arealist3 = _.find(this.arealist2,{code:o}).zlist
                this.arealist4 = []
            },
            handleItemChange3(o){
                this.form.zhen = '';
                this.arealist4 = _.find(this.arealist3,{code:o}).zlist
            }

        }
    }
</script>
<style>
	/* .liaddress .h-formbLine1 .h-elformWrap-2{
		width: 100%!important;
	}
	.liaddress .h-formbLine1 .h-elformWrap-2 .el-form-item__label{
		width: 6%!important;
	}
	.liaddress .h-formbLine1 .h-elformWrap-2 .el-form-item__content{
		width: 94%!important;
	}
	.liaddress .h-formbLine1 .h-elformWrap-2{
		display: flex;
	}
	.liaddress .h-formbLine1 .h-elformWrap-1{
		display: flex;
	}
	.liaddress .h-formbLine1 .h-elformWrap-1 .el-form-item__label{
		width: 18%!important;
	}
	.liaddress .h-formbLine1 .h-elformWrap-1 .el-form-item__content{
		width: 94%!important;
	} */
	.w-city, .w-controny {
		display: flex;
	}
	.w-controny .el-form-item {
		width: 100%;
	}
	.w-city .el-form-item {
		width: 50%;
	}
	.w-controny .el-form-item__label {
		width: 16%;
		flex-shrink: 0;
	}
	.w-city .el-form-item__label{
		width: 32%;
		flex-shrink: 0;
	}
	.w-controny .el-form-item__content {
		flex-grow: 1;
	}
	.w-city .el-form-item__content{
		flex-grow: 1;
	}
	.submit-btn-w {
		padding: 0.1rem 0.25rem;
		background-color: #1b78e6;
		border-color: #1b78e6;
	}
</style>

